import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import styles from '../coupon-templates-container/index.module.less'
import { Card, Space } from 'antd'
import { Outlet, useLocation } from 'react-router-dom'
import { compose } from 'redux'

const CampaignPopupsContainer = () => {
  const location = useLocation()

  const getNavBarTitle = () => {
    const pathName = location.pathname

    if (pathName.match(/^\/campaign-popups\/[0-9]+\/edit$/)) {
      return translate('navBar.editCampaignPopup')
    }

    if (pathName.match(/^\/campaign-popups\/new/)) {
      return translate('navBar.newCampaignPopup')
    }

    if (pathName.match(/^\/campaign-popups\/[0-9]+$/)) {
      return translate('navBar.viewCampaignPopup')
    }

    return translate('navBar.campaignPopupsTitle')
  }

  return (
    <Space className={styles['dashboard-wrapper']} orientation="vertical">
      <NavBar title={getNavBarTitle()}></NavBar>
      <Card>
        <Outlet />
      </Card>
    </Space>
  )
}

export default compose()(CampaignPopupsContainer)
